import { render, staticRenderFns } from "./ProfileVisibility.vue?vue&type=template&id=495d0cc4&scoped=true&"
import script from "./ProfileVisibility.vue?vue&type=script&lang=ts&"
export * from "./ProfileVisibility.vue?vue&type=script&lang=ts&"
import style0 from "./ProfileVisibility.vue?vue&type=style&index=0&id=495d0cc4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "495d0cc4",
  null
  
)

export default component.exports